import { useState, type FormEvent } from 'react';
import type { Rol } from '@eventos-cien/shared';
import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/Button';
import { Callout } from '../components/Callout';
import { Card } from '../components/Card';
import { Eyebrow } from '../components/Eyebrow';
import { TextField } from '../components/TextField';
import { mensajeErrorAuth } from '../lib/erroresAuth';

const ETIQUETA_ROL: Record<Rol, string> = {
  admin: 'Administración',
  asesor: 'Asesor',
  staff: 'Puerta',
};

export function PerfilScreen() {
  const { usuario, user, cerrarSesion, cambiarPassword } = useAuth();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmacion, setConfirmacion] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [exito, setExito] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setExito(false);

    if (nueva.length < 6) {
      setError('La contraseña nueva debe tener al menos 6 caracteres.');
      return;
    }
    if (nueva !== confirmacion) {
      setError('La confirmación no coincide con la contraseña nueva.');
      return;
    }

    setEnviando(true);
    try {
      await cambiarPassword(actual, nueva);
      setActual('');
      setNueva('');
      setConfirmacion('');
      setExito(true);
    } catch (err) {
      setError(mensajeErrorAuth(err));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="mx-auto max-w-xl space-y-5 p-4 sm:p-6">
      <div>
        <Eyebrow>Mi perfil</Eyebrow>
        <h1 className="mt-1 text-xl font-semibold text-texto">
          {usuario?.nombre ?? user?.email ?? 'Tu cuenta'}
        </h1>
        <p className="text-sm text-texto/60">{user?.email}</p>
      </div>

      {usuario ? (
        <div className="flex flex-wrap gap-2">
          {usuario.roles.map((r) => (
            <span key={r} className="rounded-full bg-navy/5 px-3 py-1 text-xs font-medium text-navy">
              {ETIQUETA_ROL[r]}
            </span>
          ))}
        </div>
      ) : (
        <Callout tono="alerta">
          Tu correo tiene sesión pero no está dado de alta en el sistema. Pide a un
          administrador que cree tu usuario.
        </Callout>
      )}

      <Card className="p-5">
        <h2 className="text-sm font-semibold text-texto">Cambiar contraseña</h2>
        <form className="mt-4 flex flex-col gap-4" onSubmit={onSubmit} noValidate>
          <TextField
            label="Contraseña actual"
            type="password"
            autoComplete="current-password"
            required
            value={actual}
            onChange={(e) => setActual(e.target.value)}
          />
          <TextField
            label="Contraseña nueva"
            type="password"
            autoComplete="new-password"
            required
            value={nueva}
            onChange={(e) => setNueva(e.target.value)}
          />
          <TextField
            label="Confirmar contraseña nueva"
            type="password"
            autoComplete="new-password"
            required
            value={confirmacion}
            onChange={(e) => setConfirmacion(e.target.value)}
          />
          {error && <Callout tono="error">{error}</Callout>}
          {exito && <Callout tono="exito">Contraseña actualizada.</Callout>}
          <Button type="submit" cargando={enviando}>
            Guardar contraseña
          </Button>
        </form>
      </Card>

      <Button variante="secundario" bloque onClick={() => void cerrarSesion()}>
        Cerrar sesión
      </Button>
    </div>
  );
}
